import type {ReactNode} from "react";
import {cn} from "@/lib/utils";

type Props = {
  children: ReactNode;
  className?: string;
  flush?: boolean;
  title?: string;
  description?: string;
  actions?: ReactNode;
};

export function AdminCard({children, className, flush, title, description, actions}: Props) {
  return (
    <section className={cn("admin-card", flush && "admin-card--flush", className)}>
      {(title || description || actions) ? (
        <div className={cn("admin-card__header", flush && "px-6 pt-6")}>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
            <div>
              {title ? <h2 className="admin-card__title">{title}</h2> : null}
              {description ? <p className="admin-card__description">{description}</p> : null}
            </div>
            {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
          </div>
        </div>
      ) : null}
      {children}
    </section>
  );
}
